import { render, staticRenderFns } from "./Format-0.vue?vue&type=template&id=1a97e230"
import script from "./Format-0.vue?vue&type=script&lang=js"
export * from "./Format-0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports